// extracted by mini-css-extract-plugin
export default {"container":"photos-box_container__7Ee-s","img":"photos-box_img__oQRbQ","img_active":"photos-box_img_active__WOHte"};